import React from 'react';

const FileLayerIcon = ({ width = 17, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_2388_7214)">
      <path
        d="M9.83208 15.364H2.18728C1.89896 15.3683 1.62065 15.2583 1.41319 15.058C1.20573 14.8577 1.08597 14.5835 1.08008 14.2952V2.03279C1.08597 1.74449 1.20573 1.47025 1.41319 1.26998C1.62065 1.06971 1.89896 0.9597 2.18728 0.963988H14.3729C14.5162 0.961871 14.6585 0.988006 14.7917 1.0409C14.9249 1.09379 15.0464 1.1724 15.1492 1.27225C15.252 1.37209 15.3342 1.49121 15.3909 1.6228C15.4477 1.7544 15.478 1.89588 15.4801 2.03919V9.76399L9.83208 15.364Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83203 10.3018V15.3642L15.48 9.76422H10.3856C10.314 9.76316 10.2428 9.77622 10.1762 9.80267C10.1096 9.82912 10.0489 9.86843 9.99747 9.91835C9.94606 9.96827 9.90499 10.0278 9.87661 10.0936C9.84822 10.1594 9.83307 10.2302 9.83203 10.3018Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2388_7214">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.280273 0.164062)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FileLayerIcon;
